import { render } from "./Sala2It.vue?vue&type=template&id=045cc1de"
import script from "./Sala2It.vue?vue&type=script&lang=js"
export * from "./Sala2It.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__